import { Response } from '@marketplace-web/core-api/api-client-util'
import { transformCurrencyAmountDto } from '@marketplace-web/currency/currency-data'

import {
  BumpOptionDto,
  BumpOptionModel,
  BumpOptionResp,
  BumpOptionsDto,
  BumpOptionsModel,
  BumpOrderItemDto,
  BumpOrderItemModel,
  MultiBumpDiscountDto,
  MultiBumpDiscountModel,
} from '../types/bump-options'

export const transformBumpOrderItem = (dto: BumpOrderItemDto): BumpOrderItemModel => ({
  itemId: dto.item_id,
  title: dto.title,
  imageUrl: dto.image_url,
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
})

export const transformBumpOption = (dto: BumpOptionDto): BumpOptionModel => ({
  id: `${dto.days}${dto.international ? '-int' : ''}`,
  days: dto.days,
  isDefault: dto.default,
  description: dto.description,
  isBestValue: !!dto.best_value,
  international: dto.international,
  countries: dto.countries,
  payable: transformCurrencyAmountDto(dto.payable),
  salesTax: dto.sales_tax ? transformCurrencyAmountDto(dto.sales_tax) : undefined,
  pushUpOrderItems: dto.push_up_order_items.map(transformBumpOrderItem),
})

export const transformMultiBumpDiscount = (dto: MultiBumpDiscountDto): MultiBumpDiscountModel => ({
  minPaidItemCount: dto.min_paid_item_count,
  discountPercentage: dto.discount_percentage,
})

export const transformBumpsOptions = (dto: BumpOptionsDto): BumpOptionsModel => ({
  freePushUpsCount: dto.free_push_ups_count,
  hasLocalOptions: dto.has_local_options,
  bumpableItemCount: dto.bumpable_item_count,
  discountPercentage: dto.discount_percentage,
  multiBumpDiscount: transformMultiBumpDiscount(dto.multi_bump_discount),
  options: dto.options ? dto.options.map(transformBumpOption) : [],
})

export const transformBumpOptionsResponse = (response: Response<BumpOptionResp>) =>
  transformBumpsOptions(response)
